import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, input, Input, OnInit, Optional, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { debounceTime, Observable, filter, share, startWith, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Reil } from '@app/models/hotels/Reil';
import { TrafficsService } from '@app/services/traffics.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Partner } from '@app/models/partner/IPartner';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
    selector: 'clever-reil',
    templateUrl: './reil.component.html',
    styleUrls: ['./reil.component.scss'],
    standalone: false
})
export class ReilComponent implements OnInit {
    mode = input<string>('');
    ziel = input<string>('AbfahrtBahnhof');

    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);

    zielText = signal<string>('Beliebig');
    searchObj: Observable<any>;
    mySearchControl = new FormControl();
    selectedList = signal<Reil[]>([]);
    partner: Partner;
    ops: string = '';

    destroyRef = inject(DestroyRef);

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected cdr: ChangeDetectorRef,
        protected trafficsService: TrafficsService,
        protected render: Renderer2,
        protected hotelService: HotelFiltersService,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.initPartner();
        this.initSearchChange();
        this.initFilterSub();
    }

    initPartner(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                for (let i = 0; i < this.partner?.agenturen?.length; i++) {
                    if (this.partner?.agenturen[i]?.aktiv) {
                        this.ops += this.partner?.agenturen[i]?.code + ',';
                    }
                }
            }
        });
    }

    initSearchChange() {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );

        this.searchObj = filterShare.pipe(
            switchMap(value => this.trafficsService.request({
                productType: 'railtravel',
                searchValue: value,
                subTypeTrainStation: true,
                tourOperatorList: this.ops,
                limit: 10
            }, 'completions'))
        );
    }

    initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (filter?.airportsResult?.length > 0) {
                if (JSON.stringify(this.selectedList()) !== JSON.stringify(filter?.airportsResult)) {
                    this.selectedList.set(JSON.parse(JSON.stringify(filter?.airportsResult)));
                    this.zielText.set(this.selectedList().length + ' ' + this.ziel());
                }
            } else {
                this.zielText.set('Beliebig');
            }
        });
    }


    async openModal() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    async openModalMobile() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    async closeModal() {
        this.showModal.set(false);
        this.mySearchControl.setValue('');
    }

    closeModalMobile() {
        this.showModal.set(false);
        // this.render.removeClass(document.body, 'model-open');
        this.mySearchControl.setValue('');
        this.cdr.detectChanges();
    }

    clearText() {
        this.mySearchControl.setValue('');
        this.focus.set(false);
        setTimeout(() => {
            this.focus.set(true);
        }, 50);
    }

    selectValue(item) {
        this.selectedList().push({
            name: item.name,
            code: item.code,
        });
        this.zielText.set(this.selectedList().length + ' ' + this.ziel());
    }

    isNotInlist(item): boolean {
        for (let i = 0; i < this.selectedList().length; i++) {
            if (this.selectedList()[i].code === item?.code) {
                return false;
            }
        }
        return true;
    }

    removeAllSelected() {
        this.selectedList.set([]);
        this.zielText.set('Beliebig');
    }

    removeFromSelected(k) {
        if (this.selectedList()[k]) {
            this.selectedList().splice(k, 1);
        }
        this.zielText.set(this.selectedList().length > 0 ? this.selectedList().length + '' : 'Beliebig');
    }

    take() {
        this.hotelService.airportsResult(JSON.parse(JSON.stringify(this.selectedList())), this.mode() !== 'home');
        this.closeModal();
    }
}
